import { Link } from 'react-router-dom';
import { heuteIso, istUeberfaellig } from '@beholder/shared/module/aufgaben';
import type { ModulSeiteProps } from '../../core/modul';
import { Karte as KarteRahmen, Laden, Meldung } from '../../core/ui';
import { faelligText, ueberfaelligText, useAufgaben } from './daten';
import { Personen } from './Zeilen';
import './stil.css';

/** Kleine Karte für die Projektübersicht. */
export function Karte({ projekt, ich }: ModulSeiteProps) {
  const { liste, fehler } = useAufgaben(projekt.id);
  const basis = `/p/${projekt.id}/aufgaben`;
  const heute = heuteIso();
  const aktiv = (liste ?? []).filter((a) => !a.vorschlag && a.status !== 'erledigt');
  const ueber = aktiv.filter((a) => istUeberfaellig(a, heute));
  const meine = aktiv.filter((a) => a.zugewiesen.some((p) => p.id === ich.id));
  const vorschlaege = (liste ?? []).filter((a) => a.vorschlag).length;
  // Zuerst Überfälliges, dann meine nächsten, dann der Rest nach Fälligkeit
  const wichtig = [...new Set([...ueber, ...meine, ...aktiv])].slice(0, 5);

  return (
    <KarteRahmen titel={<Link to={basis}>Aufgaben</Link>} className="auf-karte">
      <Meldung>{fehler}</Meldung>
      {!liste ? (
        <Laden />
      ) : (
        <>
          <div className="auf-karte-zahlen">
            <Link to={basis}>
              <strong>{aktiv.length}</strong> offen
            </Link>
            <Link to={basis} className={ueber.length ? 'auf-text-ueber' : ''}>
              <strong>{ueber.length}</strong> überfällig
            </Link>
            <Link to={basis}>
              <strong>{meine.length}</strong> bei mir
            </Link>
          </div>
          {vorschlaege > 0 && (
            <Link to={basis} className="auf-hinweis-vorschlaege">
              {vorschlaege === 1 ? '1 Vorschlag wartet' : `${vorschlaege} Vorschläge warten`} auf Bestätigung
            </Link>
          )}
          {wichtig.length === 0 ? (
            <p className="leise">Nichts offen.</p>
          ) : (
            <ul className="auf-karte-liste">
              {wichtig.map((a) => (
                <li key={a.id} className={istUeberfaellig(a, heute) ? 'auf-ueberfaellig' : ''}>
                  <Link to={`${basis}/${a.id}`}>{a.titel}</Link>
                  <span className={`klein ${istUeberfaellig(a, heute) ? 'auf-text-ueber' : 'leise'}`}>
                    {istUeberfaellig(a, heute) ? ueberfaelligText(a, heute) : a.faellig ? faelligText(a.faellig, heute) : ''}
                  </span>
                  <Personen personen={a.zugewiesen} ichId={ich.id} />
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </KarteRahmen>
  );
}
